import classNames from 'classnames';
import { node, string } from 'prop-types';
import React, { Children } from 'react';

import css from './Breadcrumbs.module.css';

export const Breadcrumbs = ({ children, className }) => {
  return (
    <div className={classNames(css.breadcrumbs, className)}>
      {Children.map(children, (child, index) => (
        <>
          {index !== 0 && <span className={css.breadcrumbsSeparator}>/</span>}
          {child}
        </>
      ))}
    </div>
  );
};

Breadcrumbs.defaultProps = {
  className: null,
  children: null,
};

Breadcrumbs.propTypes = {
  className: string,
  children: node,
};

export default Breadcrumbs;
